module.exports = __webpack_public_path__ + "static/assets/97926439955086f8ee4aabbd81580f17.png";